/**
 * Standard Bangladesh Army officer ranks, lowest to highest. Used as the
 * dropdown source on the officer registration form and validated server-side
 * so a free-typed rank can't slip in.
 *
 * Junior Commissioned Officer ranks are intentionally omitted — this platform
 * is for the commissioned officer corps. Add JCO/NCO ranks here if the scope
 * later widens; the registration validation reads this list directly.
 */
export const BD_ARMY_RANKS = [
  'Officer Cadet',
  '2nd Lieutenant',
  'Lieutenant',
  'Captain',
  'Major',
  'Lieutenant Colonel',
  'Colonel',
  'Brigadier General',
  'Major General',
  'Lieutenant General',
  'General',
] as const;

export type BdArmyRank = (typeof BD_ARMY_RANKS)[number];

/** Type guard — true when the value is one of the recognised ranks. */
export function isBdArmyRank(value: string): value is BdArmyRank {
  return (BD_ARMY_RANKS as readonly string[]).includes(value);
}
